var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"progress-percent-chart"},[_c('common-label',{attrs:{"title":"対応中事故の進捗率割合"},scopedSlots:_vm._u([{key:"contents",fn:function(){return [_c('common-chart',{attrs:{"chartData":_vm.chartData,"chartId":"progress-percent-chart"}})]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }